import { baseUniDriverFactory } from '../test-utils/utils/unidriver';
import { UniDriver } from '@wix/wix-ui-test-utils/unidriver';

export const draggableContainerUniDriverFactory = (base: UniDriver) => {
  return {
    ...baseUniDriverFactory(base),
  };
};

export type DraggableContainerUniDriver = ReturnType<
  typeof draggableContainerUniDriverFactory
>;
